import { useNavigate } from "react-router";
import { useEffect, useRef } from "react";

export default function Redirect({ to }: { to: string }) {
  const redirectingRef = useRef(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (redirectingRef.current) {
      return;
    }

    redirectingRef.current = true;
    navigate(to);
  }, [navigate, to]);

  return null;
}
